import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

export default function EmailConfirmation({ onConfirmed }) {
  const [status, setStatus] = useState('processing'); // processing, success, error

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        // Lê parâmetros do hash (#) e da query string (?)
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        const searchParams = new URLSearchParams(window.location.search);
        const accessToken = hashParams.get('access_token') || searchParams.get('access_token');
        const tokenHash = searchParams.get('token_hash'); // Supabase v2 PKCE flow

        const handleSuccess = () => {
          console.log('✅ Email confirmado com sucesso!');
          setStatus('success');
          window.history.replaceState({}, document.title, window.location.origin);
          setTimeout(() => { if (onConfirmed) onConfirmed(); }, 3000);
        };

        if (tokenHash) {
          // Fluxo PKCE (Supabase v2 padrão): troca o token_hash por uma sessão ativa
          const { error } = await supabase.auth.verifyOtp({
            token_hash: tokenHash,
            type: 'signup',
          });
          if (error) {
            console.warn('verifyOtp falhou, verificando sessão existente:', error.message);
            // O SDK pode já ter processado o token automaticamente (detectSessionInUrl).
            // Se já houver uma sessão ativa, o email foi confirmado com sucesso.
            const { data: sessionData } = await supabase.auth.getSession();
            if (sessionData?.session) {
              handleSuccess();
            } else {
              console.error('Erro ao confirmar email (PKCE):', error);
              setStatus('error');
            }
          } else {
            handleSuccess();
          }
        } else if (accessToken) {
          // Fluxo legado (implicit): Supabase já processou o token automaticamente
          const { data, error } = await supabase.auth.getSession();
          if (error) {
            console.error('Erro ao confirmar email:', error);
            setStatus('error');
          } else if (data?.session) {
            handleSuccess();
          } else {
            setStatus('error');
          }
        } else {
          // Sem token na URL — verifica se o SDK já processou e há sessão ativa
          const { data: sessionData } = await supabase.auth.getSession();
          if (sessionData?.session) {
            handleSuccess();
          } else {
            setStatus('error');
          }
        }
      } catch (error) {
        console.error('Erro ao processar confirmação:', error);
        setStatus('error');
      }
    };

    confirmEmail();
  }, [onConfirmed]);

  return (
    <div style={{
      background: 'linear-gradient(135deg, #e0eafc 0%, #cfdef3 100%)',
      minHeight: '100vh',
      margin: 0,
      fontFamily: "'Segoe UI', Arial, sans-serif",
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 18,
        boxShadow: '0 4px 24px rgba(25, 118, 210, 0.13)',
        padding: '48px 32px 40px 32px',
        maxWidth: 400,
        width: '100%',
        textAlign: 'center',
      }}>
        {/* Logo */}
        <div style={{
          width: 110,
          height: 110,
          margin: '0 auto 24px',
          background: '#1976d2',
          borderRadius: 12,
          boxShadow: '0 2px 8px #e0eafc',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '3rem',
        }}>
          {status === 'processing' && '⏳'}
          {status === 'success' && '✅'}
          {status === 'error' && '❌'}
        </div>

        {status === 'processing' && (
          <>
            <h1 style={{
              color: '#1976d2',
              fontSize: '2rem',
              marginBottom: 18,
              fontWeight: 700,
              letterSpacing: 1,
            }}>
              Confirmando...
            </h1>
            <p style={{
              color: '#333',
              fontSize: '1.15rem',
              marginBottom: 0,
            }}>
              Aguarde enquanto confirmamos seu e-mail...
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <h1 style={{
              color: '#1976d2',
              fontSize: '2rem',
              marginBottom: 18,
              fontWeight: 700,
              letterSpacing: 1,
            }}>
              E-mail confirmado!
            </h1>
            <p style={{
              color: '#333',
              fontSize: '1.15rem',
              marginBottom: 0,
            }}>
              Seu cadastro no <b>ClimoraX</b> foi confirmado com sucesso.<br />
              Você será redirecionado para o aplicativo em instantes...
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <h1 style={{
              color: '#d32f2f',
              fontSize: '2rem',
              marginBottom: 18,
              fontWeight: 700,
              letterSpacing: 1,
            }}>
              Erro na confirmação
            </h1>
            <p style={{
              color: '#333',
              fontSize: '1.15rem',
              marginBottom: 24,
            }}>
              Não foi possível confirmar seu e-mail.<br />
              Tente fazer login ou entre em contato com o suporte.
            </p>
            <button
              onClick={() => window.location.href = '/'}
              style={{
                background: '#1976d2',
                color: 'white',
                border: 'none',
                borderRadius: 8,
                padding: '12px 24px',
                fontSize: '1rem',
                fontWeight: 600,
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)',
              }}
            >
              Ir para Login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
